import { render, staticRenderFns } from "./DeskAttributes.vue?vue&type=template&id=edd07da8&scoped=true"
import script from "./DeskAttributes.vue?vue&type=script&lang=js"
export * from "./DeskAttributes.vue?vue&type=script&lang=js"
import style0 from "./DeskAttributes.vue?vue&type=style&index=0&id=edd07da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd07da8",
  null
  
)

export default component.exports